<script>
export default {
  name: 'ModalWindow',
  props: {
    modalcls: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      bodyMargin: '',
    }
  },
  watch: {
    visible: function(val) {
      if (val) {
        this.setBodyStyle()
      } else {
        this.removeBodyStyle()
      }
    },
  },
  mounted() {
    this.bodyMargin = document.body.style.margin
    if (this.visible) {
      this.setBodyStyle()
    }
  },
  beforeDestroy() {
    this.removeBodyStyle()
  },
  methods: {
    setBodyStyle() {
      // https://jsfiddle.net/0x0049/koodkcng/1/
      // Note: fixed elements will also need the margin
      // adjustment (like a fixed header, if you have one).
      const scrollBarWidth = window.innerWidth - document.body.offsetWidth
      document.body.style.margin = '0px ' + scrollBarWidth + 'px 0px 0px'
      document.body.style.overflow = 'hidden'
    },
    removeBodyStyle() {
      if (document.getElementsByClassName('modal-window').length) return

      document.body.style.margin = this.bodyMargin
      document.body.style.overflow = ''
    },
    closeModal() {
      // restore the style of body
      this.removeBodyStyle()
      this.$emit('close')
    },
  },
}
</script>

<template>
  <div
    v-if="visible"
    id="modal-overlay"
    class="fixed top-0 left-0 w-full h-full px-56 overflow-y-auto bg-blue-lighter z-modal"
  >
    <div id="modal-window" class="modal-window mt-17 my-7.7 pl-10 pr-12">
      <div :class="modalcls">
        <button
          class="absolute top-0 right-0 mt-3 mr-4 text-3xl cursor-pointer text-blue focus:outline-none"
          @click="closeModal"
        >
          <BaseIcon name="close" :size="30" />
        </button>
        <slot name="body" />
      </div>
    </div>
  </div>
</template>
